module.exports = __webpack_public_path__ + "static/media/slide1.0a680a1b.jpg";